import { SelectOption } from '../../types';
import { keyBy } from 'lodash-es';

export const getGarnerNetworkByName = (name: string): SelectOption | undefined => {
  const nameFormatted = name.trim().toLowerCase();
  return garnerNetworksMapByName[nameFormatted];
};

export const GARNER_NETWORKS = [
  { label: 'Samaritan Health Advantage', value: 'samaritanhealth.advantage' },
  { label: 'Samaritan Health PPO', value: 'samaritanhealth.ppo' },
  { label: 'Samaritan Health EPO', value: 'samaritanhealth.epo' },
  { label: 'Samaritan Health Choice', value: 'samaritanhealth.choice' },
  {
    label: 'HCSC BCBS Anthem Georgia Open Access POS',
    value: 'hcsc.bcbs.anthem.georgia.open-access-pos',
  },
  {
    label: 'HCSC BCBS Anthem Missouri Blue Access Choice',
    value: 'hcsc.bcbs.anthem.missouri.blue-access-choice',
  },
  {
    label: 'HCSC BCBS Anthem Wisconsin Blue Preferred POS',
    value: 'hcsc.bcbs.anthem.wisconsin.blue-preferred-pos',
  },
  { label: 'HCSC BCBS Bluecard PPO', value: 'hcsc.bcbs.bluecard-ppo' },
  { label: 'HCSC BCBS Empire Blue Access PPO EPO', value: 'hcsc.bcbs.empire.blue-access-ppo-epo' },
  {
    label: 'HCSC BCBS Florida Blue Options PPO (NetworkBlue)',
    value: 'hcsc.bcbs.florida.blue-options-ppo',
  },
  { label: 'HCSC BCBS Illinois Blue Edge PPO', value: 'hcsc.bcbs.illinois.blue-edge-ppo' },
  {
    label: 'HCSC BCBS KC - Preferred Care Blue',
    value: 'hcsc.bcbs.kansascity.preferred-care-blue',
  },
  { label: 'HCSC BCBS Anthem HealthKeepers POS', value: 'hcsc.bcbs.anthem.healthkeepers-pos' },
  { label: 'HCSC BCBS Anthem Indiana HealthSync', value: 'hcsc.bcbs.anthem.indiana.health-sync' },
  {
    label: 'HCSC BCBS Carefirst Blue Choice Advantage',
    value: 'hcsc.bcbs.carefirst.bluechoice-advantage',
  },
  { label: 'HCSC BCBS MN High Value', value: 'hcsc.bcbs.mn-high-value' },
  { label: 'HCSC BCBS Nebraska Blueprint Health', value: 'hcsc.bcbs.nebraska.blueprint-health' },
  {
    label: 'HCSC BCBS NH Blue Choice Open Access POS',
    value: 'hcsc.bcbs.anthem.nh.blue-choice-open-access',
  },
  { label: 'HCSC Blue HPN', value: 'hcsc.bcbs.blue-hpn' },
  { label: 'HCSC BCBS Blue HPN Tier 1', value: 'hcsc.bcbs.blue-hpn-tier1' },
  { label: 'HCSC BCBS Blue HPN Tier 2', value: 'hcsc.bcbs.blue-hpn-tier2' },
  { label: 'HCSC BCBS Blue HPN Tier 3', value: 'hcsc.bcbs.blue-hpn-tier3' },
  { label: 'HCSC BCBSIL PPO', value: 'hcsc.bcbs.illinois.ppo' },
  { label: 'HCSC BCBSIL PPO Tier 1', value: 'hcsc.bcbs.illinois.ppo-tier1' },
  { label: 'HCSC BCBSIL PPO Tier 2', value: 'hcsc.bcbs.illinois.ppo-tier2' },
  { label: 'HCSC BCBSIL PPO Tier 3', value: 'hcsc.bcbs.illinois.ppo-tier3' },
  { label: 'HCSC Blue Choice Options PPO', value: 'hcsc.bcbs.illinois.blue-choice-options' },
  {
    label: 'HCSC BCBS IL Blue Choice Options Tier 1',
    value: 'hcsc.bcbs.illinois.blue-choice-options-tier1',
  },
  {
    label: 'HCSC BCBS IL Blue Choice Options Tier 2',
    value: 'hcsc.bcbs.illinois.blue-choice-options-tier2',
  },
  {
    label: 'HCSC BCBS IL Blue Choice Options Tier 3',
    value: 'hcsc.bcbs.illinois.blue-choice-options-tier3',
  },
  { label: 'HCSC BCBS Texas Blue Choice PPO', value: 'hcsc.bcbs.texas.blue-choice-ppo' },
  {
    label: 'HCSC BCBS Texas Blue Choice PPO Tier 1',
    value: 'hcsc.bcbs.texas.blue-choice-ppo-tier1',
  },
  {
    label: 'HCSC BCBS Texas Blue Choice PPO Tier 2',
    value: 'hcsc.bcbs.texas.blue-choice-ppo-tier2',
  },
  {
    label: 'HCSC BCBS Texas Blue Choice PPO Tier 3',
    value: 'hcsc.bcbs.texas.blue-choice-ppo-tier3',
  },
  { label: 'Ambetter', value: 'ambetter.ambetter' },
  { label: 'BCBST Blue Network S', value: 'bcbs.tennessee.blue-network-s' },
  { label: 'BCBST Blue Network P', value: 'bcbs.tennessee.blue-network-p' },
  { label: 'BCBS Tennessee Blue Network L', value: 'bcbs.tennessee.blue-network-l' },
  { label: 'BCBS Tennessee Blue Network E', value: 'bcbs.tennessee.blue-network-e' },
  { label: 'Aetna Choice POS II', value: 'aetna.choice-pos-ii' },
  { label: 'Aetna Signature Administrators PPO', value: 'aetna.signature.administrators.ppo' },
  { label: 'Aetna Open Access Elect Choice', value: 'aetna.open-access-elect-choice' },
  { label: 'Open Access Managed Choice', value: 'aetna.open-access-managed-choice' },
  { label: 'Aetna Open Access (Aetna Select)', value: 'aetna.select-oa' },
  { label: 'Aetna Open Choice PPO', value: 'aetna.open-choice-ppo' },
  { label: 'BCBS Anthem Blue Open Access POS', value: 'bcbs.anthem.georgia.open-access-pos' },
  { label: 'Blue Card PPO', value: 'bcbs.bluecard-ppo' },
  { label: 'BCBS Illinois Blue Edge PPO', value: 'bcbs.illinois.blue-edge-ppo' },
  { label: 'Blue Access', value: 'bcbs.anthem.blue-access-ppo' },
  { label: 'BCBS Blue HPN', value: 'bcbs.blue-hpn' },
  { label: 'BCBS Blue HPN Tier 1', value: 'bcbs.blue-hpn-tier1' },
  { label: 'BCBS Blue HPN Tier 2', value: 'bcbs.blue-hpn-tier2' },
  { label: 'BCBS Blue HPN Tier 3', value: 'bcbs.blue-hpn-tier3' },
  { label: 'Care First BlueChoice Advantage', value: 'bcbs.carefirst.bluechoice-advantage' },
  { label: 'BCBS Kansas City - Preferred Care Blue', value: 'bcbs.kansascity.preferred-care-blue' },
  { label: 'BCBS Minnesota High Value Network', value: 'bcbs.mn-high-value' },
  { label: 'BCBS Anthem MO Blue Access Choice', value: 'bcbs.anthem.missouri.blue-access-choice' },
  { label: 'BCBS Anthem HealthKeepers POS', value: 'bcbs.anthem.healthkeepers-pos' },
  {
    label: 'BCBS Anthem Wisconsin Blue Preferred POS',
    value: 'bcbs.anthem.wisconsin.blue-preferred-pos',
  },
  { label: 'BCBS Anthem Indiana Health Sync', value: 'bcbs.anthem.indiana.health-sync' },
  { label: 'BCBS Nebraska - Blueprint Health', value: 'bcbs.nebraska.blueprint-health' },
  { label: 'BCBS Anthem MO Blue Preferred', value: 'bcbs.anthem.missouri.blue-preferred' },
  { label: 'BCBS Anthem Century Preferred', value: 'bcbs.anthem.century-preferred' },
  { label: 'BCBS Anthem Colorado CO Pathway', value: 'bcbs.anthem.colorado.co-pathway' },
  { label: 'BCBS Anthem Wisconsin - Blue Priority', value: 'bcbs.anthem.wisconsin.blue-priority' },
  { label: 'BCBS Empire - Blue Access PPO - EPO', value: 'bcbs.empire.blue-access-ppo-epo' },
  {
    label: 'BCBS Nebraska - Premier Select Blue Choice',
    value: 'bcbs.nebraska.premier-select-blue-choice',
  },
  { label: 'BCBS Blueshield Tandem PPO', value: 'bcbs.california.tandem-ppo' },
  { label: 'Blue Choice Options', value: 'bcbs.illinois.blue-choice-options' },
  { label: 'BCBS IL Blue Choice Options Tier 1', value: 'bcbs.illinois.blue-choice-options-tier1' },
  { label: 'BCBS IL Blue Choice Options Tier 2', value: 'bcbs.illinois.blue-choice-options-tier2' },
  { label: 'BCBS IL Blue Choice Options Tier 3', value: 'bcbs.illinois.blue-choice-options-tier3' },
  { label: 'BCBS Horizon Managed Care', value: 'bcbs.horizon.managed-care' },
  { label: 'BCBS Horizon Omnia with BlueCard PPO', value: 'bcbs.horizon.omnia-with-bluecard' },
  { label: 'BCBS Regence Utah Preferred Blue Option', value: 'bcbs.regence.preferred-blue-option' },
  { label: 'BCBS Michigan Blue Care', value: 'bcbs.michigan-blue-care' },
  { label: 'BCBS Michigan Blue Care - Tier 1', value: 'bcbs.michigan-blue-care-tier1' },
  { label: 'BCBS Michigan Blue Care - Tier 2', value: 'bcbs.michigan-blue-care-tier2' },
  { label: 'BCBS Michigan PPO - Tier 1', value: 'bcbs.michigan.ppo-tier1' },
  { label: 'BCBS Michigan PPO - Tier 2', value: 'bcbs.michigan.ppo-tier2' },
  { label: 'BCBS North Carolina Bluecard PPO', value: 'bcbs.nc.bluecard-ppo' },
  { label: 'BCBS FEP Blue', value: 'bcbs.fep.blue' },
  { label: 'BCBS IL PPO', value: 'bcbs.illinois.ppo' },
  { label: 'BCBS IL PPO Tier 1', value: 'bcbs.illinois.ppo-tier1' },
  { label: 'BCBS IL PPO Tier 2', value: 'bcbs.illinois.ppo-tier2' },
  { label: 'BCBS IL PPO Tier 3', value: 'bcbs.illinois.ppo-tier3' },
  { label: 'BCBS Texas Blue Choice PPO', value: 'bcbs.texas.blue-choice-ppo' },
  { label: 'BCBS Texas Blue Choice PPO Tier 1', value: 'bcbs.texas.blue-choice-ppo-tier1' },
  { label: 'BCBS Texas Blue Choice PPO Tier 2', value: 'bcbs.texas.blue-choice-ppo-tier2' },
  { label: 'BCBS Texas Blue Choice PPO Tier 3', value: 'bcbs.texas.blue-choice-ppo-tier3' },
  { label: 'True Blue PPO With BlueCard', value: 'bcbs.arkansas.true-blue-ppo-with-bluecard' },
  { label: 'Florida Blue Choice', value: 'bcbs.florida.blue-choice' },
  { label: 'Advantage Blue EPO', value: 'bcbs.ma.advantage-blue-epo' },
  { label: 'Preferred Care PPO', value: 'bcbs.louisiana.preferred-care-ppo' },
  {
    label: 'True Blue PPO Without BlueCard',
    value: 'bcbs.arkansas.true-blue-ppo-without-bluecard',
  },
  { label: 'Cigna PPO', value: 'cigna.ppo' },
  { label: 'Cigna Open Access Plus', value: 'cigna.open-access-plus' },
  { label: 'United Choice', value: 'uhc.choice' },
  { label: 'United Choice Plus', value: 'uhc.choice-plus' },
  { label: 'Cigna Choice Fund PPO', value: 'cigna.choice-fund-ppo' },
  { label: 'Florida Blue Blue Options PPO', value: 'bcbs.florida.blue-options-ppo' },
  {
    label: 'South Carolina Blue Network Preferred',
    value: 'bcbs.south-carolina.preferred-blue-network-ppo',
  },
  { label: 'UHC Select Plus', value: 'uhc.select-plus' },
  { label: 'UHC Options PPO', value: 'uhc.options-ppo' },
  { label: 'Cigna Local Plus', value: 'cigna.local-plus' },
  { label: 'BCBS HMSA (Hawaii) - PPO', value: 'bcbs.hawaii.ppo' },
  { label: 'BCBS MA PPO EPO', value: 'bcbs.ma.ppo-epo' },
  { label: 'BCBS Empire POS', value: 'bcbs.empire.pos' },
  { label: 'BCBS Florida Blue Care', value: 'bcbs.florida.blue-care' },
  { label: 'BCBS Highmark PPO Blue', value: 'bcbs.highmark.ppo-blue' },
  {
    label: 'BCBS Anthem Georgia Blue Choice PPO EPO',
    value: 'bcbs.anthem.georgia.blue-choice-ppo-epo',
  },
  { label: 'BCBS Oklahoma Blue Preferred PPO', value: 'bcbs.oklahoma.blue-preferred-ppo' },
  { label: 'EmblemHealth Connecticare Choice', value: 'emblemhealth.connecticare-choice' },
  { label: 'BCBS Tennessee Blue Network P Tier1', value: 'bcbs.tennessee.blue-network-p-tier1' },
  { label: 'BCBS Tennessee Blue Network P Tier2', value: 'bcbs.tennessee.blue-network-p-tier2' },
  { label: 'BCBS Tennessee Blue Network P Tier3', value: 'bcbs.tennessee.blue-network-p-tier3' },
  { label: 'BCBS Tennessee Blue Network P Tier4', value: 'bcbs.tennessee.blue-network-p-tier4' },
  { label: 'BCBS Tennessee Blue Network S Tier1', value: 'bcbs.tennessee.blue-network-s-tier1' },
  { label: 'BCBS Tennessee Blue Network S Tier2', value: 'bcbs.tennessee.blue-network-s-tier2' },
  { label: 'BCBS Tennessee Blue Network S Tier3', value: 'bcbs.tennessee.blue-network-s-tier3' },
  { label: 'BCBS Tennessee Blue Network S Tier4', value: 'bcbs.tennessee.blue-network-s-tier4' },
  { label: 'BCBS Tennessee Blue Network L Tier1', value: 'bcbs.tennessee.blue-network-l-tier1' },
  { label: 'BCBS Tennessee Blue Network L Tier2', value: 'bcbs.tennessee.blue-network-l-tier2' },
  { label: 'BCBS Tennessee Blue Network L Tier3', value: 'bcbs.tennessee.blue-network-l-tier3' },
  { label: 'BCBS Tennessee Blue Network L Tier4', value: 'bcbs.tennessee.blue-network-l-tier4' },
  { label: 'BCBS Tennessee Blue Network E Tier1', value: 'bcbs.tennessee.blue-network-e-tier1' },
  { label: 'BCBS Tennessee Blue Network E Tier2', value: 'bcbs.tennessee.blue-network-e-tier2' },
  { label: 'BCBS Tennessee Blue Network E Tier3', value: 'bcbs.tennessee.blue-network-e-tier3' },
  { label: 'BCBS Tennessee Blue Network E Tier4', value: 'bcbs.tennessee.blue-network-e-tier4' },
  { label: 'PriorityHMO', value: 'priorityhealth.priority-hmo' },
  { label: 'All - Commercial', value: 'all.commercial' },
  { label: 'Ambetter Premier', value: 'ambetter.premier' },
  {
    label: 'BCBS Anthem NH Blue Choice Open Access',
    value: 'bcbs.anthem.nh.blue-choice-open-access',
  },
  { label: 'Prominence Health Plan HMO', value: 'prominencehealthplan.hmo' },
  { label: 'Prominence Health Plan PPO', value: 'prominencehealthplan.ppo' },
];

const garnerNetworksMapByName = keyBy(GARNER_NETWORKS, (network) =>
  network.label.trim().toLowerCase(),
);
